<template>
    <div class="wrapper">
        <div class="topo-header centro">
            <botao-voltar tituloRota="Ocorrencia" />
            <h1>{{ ocorrenciaForm.id ? "Editar" : "Nova" }} Ocorrência</h1>
        </div>
        <div class="tab-dados-basicos">
            <div class="form centro">
                <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro"/>
                <p>Os campos com asterisco (*) são de preenchimento obrigatório.</p>                
                <form @submit.prevent="enviarForm">
                    <div class="caixa-form item">
                        <div class="flexbox-1">
                            <div v-if="ocorrenciaForm.id" class="topo-cad status-item">
                                <label><b>Ocorrência N°:</b></label>
                                <p>{{ ocorrenciaForm.id }}</p>
                            </div>
                            <div v-if="ocorrenciaForm.id" class="item status-item">
                                <label><b>Status:</b></label>
                                <p>{{ formatarStatus (ocorrenciaForm.status) }}</p>
                            </div>
                        </div>
                        <div class="flexbox-1">
                            <div class="item">
                                <label><b>{{ possuiAsterisco("Título:") }}</b></label>
                                <input type="text" placeholder="Digite o titulo" v-model="ocorrenciaForm.titulo" />
                            </div>
                            <div class="item"> 
                                <label><b>Tipo:</b></label>
                                <select id="tipo" v-model="ocorrenciaForm.tipo">
                                    <option value="melhoria" title="Tem uma ideia para melhorar o sistema? Utilize essa opção.">Sugestão</option>
                                    <option value="erro" title="Encontrou um problema? Informe-nos para que possamos corrigir.">Reporte de erro</option>
                                    <option value="duvida" title="Tem alguma pergunta ou precisa de esclarecimento? Selecione essa opção.">Dúvida</option>
                                    <option value="elogio" title="Tem algum elogio? Selecione essa opção.">Elogio</option>
                                    <option value="reclamacao" title="Deseja fazer alguma reclamação? Selecione essa opção.">Reclamação</option>
                                </select>
                            </div> 
                            <div class="item">
                                <label><b>{{ possuiAsterisco("Descrição:") }}</b></label>
                                <textarea
                                    v-model="ocorrenciaForm.descricao"
                                    name="body"
                                    class="textarea"
                                    id="body"
                                    @input="resize($event)"
                                    placeholder="Descreva a ocorrência"
                                >
                                </textarea>
                                </div>
                                <div class="item anexo-item">
                                    <label for="file-upload"><b>Anexo:</b></label>

                                    <label class="custom-file-upload" for="file-upload">
                                        Selecionar arquivo
                                    </label>
                                    
                                    <div class="item">
                                    <span class="texto-aviso"> <strong class="texto-atencao">Atenção:</strong>
                                        <span class="texto-italico">Somente arquivos em PDF, JPG, PNG e JPEG serão aceitos.</span>
                                    </span>
                                    </div>

                                    <span class="nome-arquivo" v-if="ocorrenciaForm.file">
                                        {{ ocorrenciaForm.file.name }}
                                    </span>

                                    <input
                                        id="file-upload"
                                        type="file"
                                        @change="handleFileUpload"
                                        accept=".pdf,.jpg,.png,.jpeg"
                                    />
                                </div>
                            </div>
                        <div class="bt-salvar">
                            <button id="botao-salvar" title="Criar/Atualizar" type="submit">
                                <img id="spinner-loading" class="spinner-loading"
                                    src="../../assets/imagens/loadingSpinner.gif" alt="Spinner de carregamento">
                                <p id="conteudo-botao">{{ ocorrenciaForm.id ? "Atualizar" : "Criar" }}</p>
                            </button>
                        </div>
                    </div>
                </form>
                <BannerContato style="margin-top: 20px;" />
            </div>
        </div>
    </div>
</template>

<script lang="js">
    import OcorrenciaApi from "../../services/OcorrenciaApi";
    import BotaoVoltar from "../../components/BotaoVoltar.vue";
    import MsgErroFormularios from "../MsgErroFormularios";
    import BannerContato from "./BannerContato.vue";


    export default {
        name: "ocorrenciaForm",
        props: {
            ocorrencia: {
                type: Object,
                required: false,
            },
        },
        data() {
            return {
                count: -1,
                count1: null,
                filess: null,
                carregando: true,
                erro: false,
                msgErros: {
                    titulo: '',
                    descricao: '',
                    default: '',
                },
                ocorrenciaForm: this.ocorrencia
                    ? {
                        id: this.ocorrencia.id,
                        titulo: this.ocorrencia.titulo,
                        descricao: this.ocorrencia.descricao,
                        tipo: this.ocorrencia.tipo,
                        status: this.ocorrencia.status,
                        file: null,
                    }
                    : {
                        id: null,
                        titulo: null,
                        descricao: null,
                        tipo: 'melhoria',
                        status: 'aberto',
                        file: null,
                    },
            };
        },
        components: {
            BotaoVoltar,
            MsgErroFormularios,
            BannerContato,
        },
        created() {
            this.OcorrenciaApi = new OcorrenciaApi();
        },
        methods: {
        formatarStatus(valor) {
            if (valor === 'aberto') {
                return 'Aberto';
            } else if (valor === 'em_andamento') {
                return 'Em Andamento';
            } else if (valor === 'finalizado') {
                return 'Finalizado';
            }
        },
        formatarTipo(valor) {
            if (valor === 'melhoria') {
                return 'Sugestão';
            } else if (valor === 'erro') {
                return 'Reporte de Erro';
            } else if (valor === 'duvida') {
                return 'Dúvida';
            } else if (valor === 'elogio') {
                return 'Elogio';
            } else if (valor === 'reclamacao') {
                return 'Reclamação';
            }
        },
        resize(e) {
            e.target.style.height = 'auto'
            e.target.style.height = `${e.target.scrollHeight}px`
        },
            handleFileUpload(event) {
                this.ocorrenciaForm.file = event.target.files[0]; // Guarda o arquivo selecionado
            },
            fecharErro() {
                this.erro = false;
            },
            mudarBotaoSalvar(textoBotao) {
                let botaoSalvar = document.getElementById("botao-salvar");
                let conteudoBotao = document.getElementById("conteudo-botao");
                let spinnerLoading = document.getElementById("spinner-loading");

                let novoTextoConteudoBotao = "Carregando"

                //mudar para o carregando
                botaoSalvar.disabled = true;
                botaoSalvar.style.backgroundColor = "gray"
                conteudoBotao.innerHTML = novoTextoConteudoBotao;
                conteudoBotao.style.display = "inline-block"
                spinnerLoading.style.visibility = "visible"
                spinnerLoading.style.position = "relative"

                if (this.erro == true) {
                    //mudar para o padrão (da aba dados básicos)
                    botaoSalvar.disabled = false;
                    botaoSalvar.style.backgroundColor = "#005516"
                    conteudoBotao.innerHTML = textoBotao;
                    spinnerLoading.style.visibility = "hidden"
                    spinnerLoading.style.position = "absolute"
                }
            },
            async enviarForm() {
                let conteudoBotao = document.getElementById("conteudo-botao");
                const textoConteudoBotao = conteudoBotao.innerHTML;
                
                let flag = this.validarForm(this.ocorrenciaForm);

                if (flag == 1) {
                    this.erro = true;
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    return false
                }

                try {
                    this.carregando = true;
                    this.erro = false;
                    

                    this.mudarBotaoSalvar(textoConteudoBotao);

                    if (this.OcorrenciaApi.cancelTokens.setOcorrencia) {
                        this.OcorrenciaApi.cancelTokens.setOcorrencia.cancel();
                    }

                    let data;
                    data = await this.OcorrenciaApi.setOcorrencia(
                        this.ocorrenciaForm
                    );

                    this.$root.$emit('ocorrenciasAtualizadas');

                    var rota = this.$router;
                    setTimeout(function () {
                        rota.push({
                            name: "OcorrenciasShow",
                            params: {
                                id: data.id,
                            },
                        });
                    }, 1000);
                    //window.location.reload();
                } catch (err) {
                    if (this.OcorrenciaApi.isCancel(err)) {
                        return;
                    }
                    console.log(err);
                    this.carregando = false;
                    this.erro = true;

                    this.mudarBotaoSalvar(textoConteudoBotao)

                    const { response } = err;
                    if (response && response.data) {
                      if (response.data.anexo) {
                          this.msgErros = {
                              default: "Formato de arquivo inválido. Somente arquivos em PDF, JPG, PNG e JPEG são aceitos."
                          };
                      } else {
                          this.msgErros = response.data;
                      }
                  } else {
                      this.msgErros = {
                          default: "Houve um erro ao salvar o registro. Por favor tente novamente."
                      };
                  }
                }
            },
            
            validarForm(ocorrenciaForm) {
                let flag = 0;

                //Resetar as mensagens de erro
                this.msgErros.titulo = ''
                this.msgErros.descricao = ''
                this.msgErros.default = ''

                //Titulo não pode estar em branco
                if (ocorrenciaForm.titulo == null || ocorrenciaForm.titulo == '') {
                    this.msgErros.titulo = "O campo titulo não foi preenchido.";
                    flag = 1;
                }
                if (ocorrenciaForm.descricao == null || ocorrenciaForm.descricao == '') {
                    this.msgErros.descricao = "O campo descrição não foi preenchido.";
                    flag = 1;
                }

                return flag;
            },
            possuiAsterisco(texto) {
                var texto_final = "* " + texto
                return texto_final
            },
        },
    };
</script>

<style lang="scss">
.topo-header.centro {
  display: flex;
  align-items: center;
  flex-wrap: wrap; /* Permite que os itens quebrem para a próxima linha */
  gap: 10px; /* Espaçamento entre os itens */

  h1 {
    font-size: 1.8rem; /* Tamanho da fonte do título */
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
}

.texto-aviso {
  font-size: 0.92rem;
}
.texto-atencao {
  color: red;
}
.texto-italico {
  font-size: 0.9rem;
  font-style: italic;
}
.flexbox-1 {
  display: flex;
  flex-wrap: wrap; /* Permite que os itens quebrem para a próxima linha */
  justify-content: space-between; /* Distribui o espaço entre os itens */
  align-items: flex-start; /* Alinha os itens ao início */
  gap: 20px;

  .item, 
  .status-item {
    flex: 1 1 calc(50% - 10px); /* Ocupa aproximadamente metade da largura, considerando o gap */

    label,
        p {
        display: block;
        width: 100%;
    }

    input[type="text"],
    select,
    textarea {
      width: 100%;
    }

    @media (max-width: 768px) { /* Em telas menores, ocupa a largura total */
      flex: 1 1 100%;
    }
  }
}
.anexo-item {
  display: flex;
  flex-direction: column; // <-- muda de linha para coluna
  align-items: flex-start;
  gap: 6px;
  margin-top: 8px;

  label {
    margin: 0;
    white-space: nowrap;
  }

  .custom-file-upload {
    padding: 6px 12px;
    cursor: pointer;
    background-color: #ffffff;
    color: white;
    border-radius: 4px;
    // font-weight: bold;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .nome-arquivo {
    font-size: 0.9rem;
    color: #333;
    word-break: break-word;
  }

  input[type="file"] {
    display: none !important;
  }
}

.form.centro {
  max-width: 900px; /* Limita a largura máxima do formulário */
  margin: 0 auto; /* Centraliza o formulário */
  padding: 20px; /* Adiciona preenchimento interno */
}

.status-item {
  text-align: left;

  label,
  p {
    display: block;
    width: 100%;
  }
}

</style>
